import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../loginSlice";
import { unhealthyGameConfig } from "../../data/unhealthyGameData";
import "./intro.css";

const INTRO_DELAY_MS = 9000;

function Intro() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { status, user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (status === "idle" && !user) {
      dispatch(loginUser());
    }
  }, [dispatch, status, user]);

  const [minWaitPassed, setMinWaitPassed] = useState(false);

  const goToGame = useCallback(() => {
    navigate("/game", { replace: true, state: { fromIntro: true } });
  }, [navigate]);

  useEffect(() => {
    if (status === "failed") {
      navigate("/login", { replace: true });
    }
  }, [status, navigate]);

  useEffect(() => {
    if (status === "succeeded" && !user) {
      navigate("/login", { replace: true });
    }
  }, [status, user, navigate]);

  useEffect(() => {
    const body = document.body;
    const prev = {
      image: body.style.backgroundImage,
      size: body.style.backgroundSize,
      position: body.style.backgroundPosition,
      repeat: body.style.backgroundRepeat,
      attachment: body.style.backgroundAttachment,
      overflow: body.style.overflow,
    };
    const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
    const bg = `${base}${unhealthyGameConfig.introBackground}`;
    body.style.backgroundImage = `url(${bg})`;
    body.style.backgroundSize = "cover";
    body.style.backgroundPosition = "center center";
    body.style.backgroundRepeat = "no-repeat";
    body.style.backgroundAttachment = "fixed";
    body.style.overflow = "hidden";

    return () => {
      body.style.backgroundImage = prev.image;
      body.style.backgroundSize = prev.size;
      body.style.backgroundPosition = prev.position;
      body.style.backgroundRepeat = prev.repeat;
      body.style.backgroundAttachment = prev.attachment;
      body.style.overflow = prev.overflow;
    };
  }, []);

  useEffect(() => {
    document.title = unhealthyGameConfig.title;
  }, []);

  useEffect(() => {
    const t = setTimeout(() => setMinWaitPassed(true), INTRO_DELAY_MS);
    return () => clearTimeout(t);
  }, []);

  const showNext = minWaitPassed;

  if (status === "loading" || (status === "idle" && !user)) {
    return (
      <div className="quiz-loader-container">
        <div className="quiz-loader" />
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return (
    <div className="intro-page">
      <div className="video-container intro-video-wrap">
        <video autoPlay muted playsInline onEnded={goToGame}>
          <source src="https://2023-extramileplay-php.s3.ap-south-1.amazonaws.com/UAT/unheathy-lifestye/new_version.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="intro-next-row">
        {showNext ? (
          <button type="button" className="intro-next-button" onClick={goToGame}>
            Next
          </button>
        ) : null}
      </div>

    </div>
  );
}

export default Intro;
